import { RefereeDetail, ReferralLandingPage } from '../../types'
import { LocalStorageKeys } from '../../types/LocalStorageKeys'
import { fetchReferralLandingPage } from '../../clients/pages'
import { fromStrapiReferralLandingPage } from '../../helpers/mapping/referral-landing-page'
import { getUserRefereeDetails } from '../../clients/user'

class ReferralLandingPageRepository {
    async retrieveReferralLandingPage(): Promise<ReferralLandingPage> {
        const data = await fetchReferralLandingPage()
        return fromStrapiReferralLandingPage(data)
    }

    async getReferreeDetails(ids: string[]): Promise<RefereeDetail[]> {
        const data = await getUserRefereeDetails(ids)
        return data
    }

    setReferralCode(referralCode?: string) {
        if (referralCode) {
            localStorage.setItem(LocalStorageKeys.REFERRAL_CODE, referralCode)
        } else {
            localStorage.removeItem(LocalStorageKeys.REFERRAL_CODE)
        }
    }

    getReferralCode(): string | undefined {
        return localStorage.getItem(LocalStorageKeys.REFERRAL_CODE) ?? undefined
    }
}

export default ReferralLandingPageRepository